module.exports = __webpack_public_path__ + "static/Acousma_panel-86330852e7265842a33d22e7873523ef.png";